var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VLayout,[_c(_setup.VFlex,[_c(_setup.VRuntimeTemplate,{attrs:{"template":_vm.customTemplate,"template-props":_setup.runtimeContext}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }